import { VE_OPEN_POPUP } from '../custom-events'

export const appStore = {
    isMobile: window.innerWidth < 1024,
    showSearch: false,
    lightboxImage: '',
    lightboxImageAlt: '',
    isMobileNavOpen: false,
    openPopup: (popupId) => {
        if (!popupId) return
        const el = document.getElementById('popup-' + popupId);
        if (el.parentNode.nodeName !== 'BODY') {
            document.body.appendChild(el);
        }
        window.dispatchEvent(new CustomEvent(VE_OPEN_POPUP, { detail: { popupId } }))
    },
}
